export default __webpack_public_path__ + "static/media/cover.327c0740.jpg";